import React, {useEffect, useState} from 'react'
import LiveTVScoreboard from "./LiveTVScoreboard";

/**
 * Ein Board in der modernen TV-Ansicht (Darstellung "tvmodern"). Die Anzeige-Einstellungen (Average, Last, Darts, Finishweg) gelten für alle Boards
 * und werden über das Zahnrad der Live-Ansicht gesteuert (LiveTVEinstellungen).
 */
export default function LiveTVModernGame({game, proBoardName, playerIdsChecked, boardId, showAverage, showLastThrow, showDarts, showFinish, showBoard, onDetail}) {

    const [boardName, setBoardName] = useState(proBoardName);

    useEffect( () => {
        if( game !== undefined) {
            setBoardName(game.boardName);
        }
    } ,[game]);

    return <div className="darthelfer-background-blue">
        <LiveTVScoreboard key={"key_live_tv_board_" + boardId} game={game} boardName={boardName} checkedPlayerIds={playerIdsChecked}
                          showAverage={showAverage} showLastThrow={showLastThrow} showDarts={showDarts} showFinish={showFinish} showBoard={showBoard}
                          onClick={game !== undefined ? () => onDetail(game.boardId) : undefined}/>
    </div>
}
